<template>
  <div id="Login">
    <img
      src="../../../../static/img/logo.png"
      alt="logo"
    >
    <el-form @submit.prevent="logar">
      <label
        class="label"
        for="campo_cpf"
      >CPF:</label>
      <el-input
        v-model.trim="data.cpf"
        @keypress.enter="logar()"
        v-mask="'###.###.###-##'"
        name="campo_cpf"
        type="text"
        placeholder="Digite o seu CPF..."
        tabindex="2"
        auto-complete="off"
        required
      />
      <label
        class="label"
        for="campo_senha"
      >SENHA:</label>
      <el-input
        v-model.trim="data.password"
        show-password
        @keypress.enter="logar()"
        name="campo_senha"
        type="password"
        placeholder="Digite a sua senha..."
        tabindex="3"
        auto-complete="off"
        required
      />
      <el-button
        class="botao-vermelho"
        @click.prevent="logar()"
        :loading="logando"
        tabindex="4"
        style="cursor:pointer;"
        title="Conectar"
        size="medium"
      >
        <span v-text="!logando ? 'CONECTAR' : 'CONECTANDO...'" />
      </el-button>
    </el-form>
  </div>
</template>

<script>
import http from '@/services/axios'
import services from '@/services'
import { cloneDeep } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { isCpfCnpj } from '@/assets/js/helpers'

export default {
  name: 'Login',
  data() {
    return {
      data: {
        cpf: '',
        password: ''
      },
      message: [],
      isValid: true,
      logando: false
    }
  },
  computed: {
    ...mapGetters(['getEmbarcador'])
  },
  methods: {
    ...mapActions({
      setUsuario: 'setUsuario',
      setTotalFretesRascunho: 'setTotalFretesRascunho'
    }),
    async logar() {
      if (process.env.NODE_ENV[0] !== 'd') {
        this.validarCpf()
      }
      this.validarSenha()

      if (this.isValid) {
        try {
          this.logando = true
          delete http.defaults.headers.common['Authorization']
          let response = await services.Auth.login(this.data)

          if (response) {
            let usuario = response.data.usuario

            http.defaults.headers.common[
              'Authorization'
            ] = `Bearer ${response.data.truckme}`
            localStorage.setItem('truckme-auth', response.data.truckme)

            this.setUsuario(cloneDeep(usuario))

            this.$router.push({ name: 'ParceiroContratacao' })
          } else {
            this.$store.dispatch('setLoginExpired', false)
          }
        } catch (e) {}
        this.logando = false
      } else {
        this.$swal('Atenção!', this.message.join(' '), 'error')
        this.message = []
        this.isValid = true
      }
    },
    validarCpf() {
      if (this.data.cpf === '') {
        this.message.push('CPF: Campo obrigatório')
        this.isValid = false
      } else {
        if (!isCpfCnpj(this.data.cpf)) {
          this.message.push('CPF: Valor inválido')
          this.isValid = false
        }
      }
    },
    validarSenha() {
      if (this.data.password === '') {
        this.message.push('SENHA: Campo obrigatório')
        this.isValid = false
      }
    }
  },
  mounted() {
    localStorage.removeItem('truckme-vuex')
    localStorage.removeItem('truckme-auth')
  }
}
</script>

<style lang="css" scoped>
#Login{
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 height: 100vh;
}
#Login img{
 width: 300px;
}
#Login .label{
 font-size: small;
}
#Login .el-form{
 width: 400px;
 display: flex;
 flex-wrap: wrap;
 row-gap: 10px;
 margin-top: 20px;
}

#Login .el-button{
 margin-top: 20px;
}

@media screen and (max-width: 768px) {
  #Login{
    min-width: 100%;
    padding: 0 30px;
  }
  #Login .el-form{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/modules/Auth/components/Login.vue